export const POST_SCHOOL_PLANS = [
    { value: 'university_clear', label: 'Ingresar a la universidad, ya tengo claro qué estudiar. 🎓' },
    { value: 'university_unsure', label: 'Ingresar a la universidad, pero aún requiero reflexionar sobre mi decisión de carrera. 🧭' },
    { value: 'explore_options', label: 'Tomarme un tiempo para explorar opciones o tomar un curso antes de decidir. 🔍📚' },
    { value: 'work_instead', label: 'No planeo ir a la universidad o educación superior, prefiero directamente trabajar 🚫' },
    { value: 'need_guidance', label: 'No estoy seguro/a, necesito orientación. ❓' }
]